import type { EnumUnion } from '@dresscode-frontend/utility-types';

import type {
  TestSetListItem,
  TestSetStatus,
} from '@/features/stacktrace/test-sets/-query/type';

/**
 * テストスイート詳細 > テストセットタブのテーブル列ID。
 *
 * 表示項目:
 *   テストセット名 / ステータス / 担当者 / 開始日 / 完了日 /
 *   OK / NG / スキップ / 不具合チケット数
 */
export const TestSetTableColumns = {
  NAME: 'NAME',
  STATUS: 'STATUS',
  STATUS_LABEL: 'STATUS_LABEL',
  OWNER: 'OWNER',
  PERIOD_FROM: 'PERIOD_FROM',
  PERIOD_TO: 'PERIOD_TO',
  OK_COUNT: 'OK_COUNT',
  NG_COUNT: 'NG_COUNT',
  SKIP_COUNT: 'SKIP_COUNT',
  DEFECT_TICKET_COUNT: 'DEFECT_TICKET_COUNT',
} as const;
export type TestSetTableColumns = EnumUnion<typeof TestSetTableColumns>;

type TestSetNameColumn = {
  id: string;
  name: string;
};

type TestSetOwnerColumn = {
  personId: string;
  name: string | null;
};

export type TestSetTableRowData = {
  [TestSetTableColumns.NAME]: TestSetNameColumn;
  [TestSetTableColumns.STATUS]: TestSetStatus | undefined;
  [TestSetTableColumns.STATUS_LABEL]: string | undefined;
  [TestSetTableColumns.OWNER]: TestSetOwnerColumn;
  [TestSetTableColumns.PERIOD_FROM]: string | null;
  [TestSetTableColumns.PERIOD_TO]: string | null;
  [TestSetTableColumns.OK_COUNT]: number;
  [TestSetTableColumns.NG_COUNT]: number;
  [TestSetTableColumns.SKIP_COUNT]: number;
  [TestSetTableColumns.DEFECT_TICKET_COUNT]: number;
};

export const convertTestSetItemToTableRow = (
  item: TestSetListItem,
): TestSetTableRowData => {
  return {
    [TestSetTableColumns.NAME]: { id: item.id, name: item.name },
    [TestSetTableColumns.STATUS]: item.status as TestSetStatus | undefined,
    [TestSetTableColumns.STATUS_LABEL]: undefined,
    [TestSetTableColumns.OWNER]: {
      personId: item.ownerPersonId,
      name: item.ownerPersonName,
    },
    [TestSetTableColumns.PERIOD_FROM]: item.periodFrom,
    [TestSetTableColumns.PERIOD_TO]: item.periodTo,
    [TestSetTableColumns.OK_COUNT]: item.okCount,
    [TestSetTableColumns.NG_COUNT]: item.ngCount,
    [TestSetTableColumns.SKIP_COUNT]: item.skipCount,
    [TestSetTableColumns.DEFECT_TICKET_COUNT]: item.defectTicketCount,
  };
};
